/**
 * Commercial name: SEO-Presta
 * Proprietary-license whose copyright belongs to the Licensor PRESTA MODULE, a company registered under French law
 * under the number 528 531 767, located 90 rue Stanislas Torrents 13006 Marseille
 * support@presta-module.com https://www.presta-module.com
 *
 * SEO-Presta’ source codes are protected and Licensees are not allowed to create any Derivated Work.
 * The distribution or resale of SEO-Presta is strictly forbidden.
 *
 * SEO-Presta shall be used for Licensees’ own use, which allows Customization.
 *
 * Licensees shall not distribute nor resale publicly any Customization of SEO-Presta. However, Licensees are allowed
 * to sale a customization of SEO-Presta as part of a service provided to a designated customer.
 *
 * Limitation of Liability: Under no circumstances and under no legal theory, whether in tort (including negligence),
 * contract, or otherwise, shall the Licensor be liable to anyone for any indirect, special, incidental, or
 * consequential damages of any character arising as a result of this License including, without limitation, damages
 * for loss of goodwill, work stoppage, computer failure or malfunction, or any and all other commercial damages
 * or losses. This limitation of liability shall not apply to the extent applicable law prohibits such limitation.
 *
 * Attribution notice: SEO-Presta is a Derivated Work from an Original Work created by PrestaShop SA
 * and its contributors which can be found at https://github.com/PrestaShop/PrestaShop
 */
import LocalizationException from '../exception/localization';
import NumberSpecification from './number';

/**
 * Currency display option: symbol notation.
 */
const CURRENCY_DISPLAY_SYMBOL = 'symbol';


class PriceSpecification extends NumberSpecification {
    /**
     * Price specification constructor.
     *
     * @param string positivePattern CLDR formatting pattern for positive amounts
     * @param string negativePattern CLDR formatting pattern for negative amounts
     * @param NumberSymbol symbol Number symbol
     * @param int maxFractionDigits Maximum number of digits after decimal separator
     * @param int minFractionDigits Minimum number of digits after decimal separator
     * @param bool groupingUsed Is digits grouping used ?
     * @param int primaryGroupSize Size of primary digits group in the number
     * @param int secondaryGroupSize Size of secondary digits group in the number
     * @param string currencySymbol Currency symbol of this price (eg. : €)
     * @param currencyCode Currency code of this price (e.g.: EUR)
     *
     * @throws LocalizationException
     */
    constructor(
        positivePattern,
        negativePattern,
        symbol,
        maxFractionDigits,
        minFractionDigits,
        groupingUsed,
        primaryGroupSize,
        secondaryGroupSize,
        currencySymbol,
        currencyCode,
    ) {
        super(
            positivePattern,
            negativePattern,
            symbol,
            maxFractionDigits,
            minFractionDigits,
            groupingUsed,
            primaryGroupSize,
            secondaryGroupSize,
        );
        this.currencySymbol = currencySymbol;
        this.currencyCode = currencyCode;

        if (!this.currencySymbol || typeof this.currencySymbol !== 'string') {
            throw new LocalizationException('Invalid currencySymbol');
        }

        if (!this.currencyCode || typeof this.currencyCode !== 'string') {
            throw new LocalizationException('Invalid currencyCode');
        }
    }

    /**
     * Get type of display for currency symbol.
     *
     * @return string
     */
    static getCurrencyDisplay() {
        return CURRENCY_DISPLAY_SYMBOL;
    }

    /**
     * Get the currency symbol
     * e.g.: €.
     *
     * @return string
     */
    getCurrencySymbol() {
        return this.currencySymbol;
    }

    /**
     * Get the currency ISO code
     * e.g.: EUR.
     *
     * @return string
     */
    getCurrencyCode() {
        return this.currencyCode;
    }
}

export default PriceSpecification;
